import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Input,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../../_models/field.interface';
import { ButtonComponent } from '../button/button.component';
import { ButtonImageComponent } from '../button/buttonImage.component';
import { LabelComponent } from '../label/label.component';
import { LabelImageComponent } from '../label/labelImage.component';
import { InputComponent } from '../input/input.component';
import { ImageComponent } from '../image/image.component';
import { SliderComponent } from '../slider/slider.component';
import { RadiobuttonComponent } from '../radiobutton/radiobutton.component';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { CheckboxCustomComponent } from '../checkbox/checkboxCustom.component';
import { CarouselComponent } from '../carousel/carousel.component';
import { RadiobuttonCustomComponent } from './../radiobutton/radiobuttonCustom.component';
import { CircleProgressComponent } from '../circle-progress/circle-progress.component';
import { ButtonSubmitComponent } from '../button/buttonSubmit.component';
import { SelectComponent } from '../select/select.component';
import { CardConteudoComponent } from '../card-conteudo/card-conteudo.component';
import { CardCarouselComponent } from '../card-carousel/card-carousel.component';
import { NoDataComponent } from '../no-data/no-data.component';
import { TextAreaComponent } from './../input/text-area.component';
import { DesafiosCarouselComponent } from '../desafios-carousel/desafios-carousel.component';
import { UploadFilesGenericComponent } from '../upload/upload-files-generic.component';
import { SliderToggleComponent } from '../slider/slider-toggle.component';

const componentMapper = {
  button: ButtonComponent,
  label: LabelComponent,
  labelImage: LabelImageComponent,
  buttonImage: ButtonImageComponent,
  input: InputComponent,
  image: ImageComponent,
  slider: SliderComponent,
  radioButton: RadiobuttonComponent,
  checkbox: CheckboxComponent,
  carousel: CarouselComponent,
  radioButtonCustom: RadiobuttonCustomComponent,
  circleProgress: CircleProgressComponent,
  buttonSubmit: ButtonSubmitComponent,
  select: SelectComponent,
  contentCard: CardConteudoComponent,
  carouselCard: CardCarouselComponent,
  noData: NoDataComponent,
  textArea: TextAreaComponent,
  desafiosCarousel: DesafiosCarouselComponent,
  uploadFilesGeneric: UploadFilesGenericComponent,
  checkboxCustom: CheckboxCustomComponent,
  sliderToggle: SliderToggleComponent,
};
@Directive({
  selector: '[dynamicField]',
})
export class DynamicFieldDirective implements OnInit {
  @Input() field: FieldConfig;
  @Input() group: UntypedFormGroup;
  componentRef: any;
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) {}
  ngOnInit() {
    const factory = this.resolver.resolveComponentFactory(
      componentMapper[this.field.type]
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.field = this.field;
    this.componentRef.instance.group = this.group;
  }
}
